export const CODE_LENGTH_MAX = 50;
export const ESTIMATED_COST_MAX = 9999999999;
export const ESTIMATED_HOURS_MAX = 99999999;
export const NUMERIC_UDF_MAX_LENGTH = 999999999.9999;
export const STRING_MAX_LENGTH = 255;
